import {
  HERO_SLIDE_BACKDROP,
  HERO_SLIDE_GLOW,
  HERO_SLIDE_GLOW_ROSE,
  HERO_SLIDE_TOP_SHINE,
} from "./hero-slide-theme.constants";

type HeroSlideBackdropProps = {
  accent?: "amber" | "rose";
};

export const HeroSlideBackdrop = ({
  accent = "amber",
}: HeroSlideBackdropProps) => (
  <div className={HERO_SLIDE_BACKDROP}>
    <div
      className={accent === "rose" ? HERO_SLIDE_GLOW_ROSE : HERO_SLIDE_GLOW}
    />
    <div className={HERO_SLIDE_TOP_SHINE} />
  </div>
);
